import { FC } from 'react'
import classNames from 'classnames'

import { CarouselContainerProps } from './types'

// TODO: add will-change-transform	transform-gpu when autoscroll plugin is used
export const Container: FC<CarouselContainerProps> = ({
  className,
  ...props
}) => <ul className={classNames('grid grid-flow-col ', className)} {...props} />
